import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Spinner,
} from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import { Button } from './Button';
import React from 'react';

type DefaultAlertDialogProps = {
  dialogHeaderText: string;
  dialogBodyText: string;
  actionText?: string;
  isOpen: boolean;
  isLoading?: boolean;
  onConfirmedAction: (event: React.MouseEvent<unknown, MouseEvent>) => void;
  onCancel: () => void;
  headerParams?: string[];
  bodyParams?: string[];
  actionParams?: string[];
  variant?: 'danger' | 'submit';
};
export const DefaultAlertDialog: React.FC<DefaultAlertDialogProps> = ({
  dialogHeaderText,
  dialogBodyText,
  actionText = 'defaultAlertDialog.defaultActionText',
  isOpen,
  isLoading,
  onConfirmedAction,
  onCancel,
  headerParams,
  bodyParams,
  actionParams,
  variant = 'danger',
}: DefaultAlertDialogProps) => {
  const translate = useTranslate();

  return (
    <AlertDialog
      isOpen={isOpen}
      /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */
      leastDestructiveRef={null as any}
      onClose={onCancel}
      closeOnOverlayClick={false}
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader fontSize="lg" fontWeight="bold">
          {translate(dialogHeaderText, headerParams)}
        </AlertDialogHeader>

        <AlertDialogBody>
          {translate(dialogBodyText, bodyParams)}
        </AlertDialogBody>

        <AlertDialogFooter>
          <Button variant={variant} onClick={onConfirmedAction}>
            {isLoading ? <Spinner /> : translate(actionText, actionParams)}
          </Button>
          <Button variant="cancel" ref={undefined} onClick={onCancel} ml={3}>
            {translate('cancelButton.text')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
